module.exports = __webpack_public_path__ + "static/media/edit-icon.cdebb5e4.svg";